// vuex
import { mapMutations } from 'vuex'
// types
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_CLEAR_MODULE,
  USER_MODULE_NAME,
  USER_CLEAR_MODULE
} from '@/store/types'

/**
 * @module
 * @name Logout
 * @description Logout user, clearing all browser info and redirecting to login.
 */
export default {
  name: 'Logout',

  mounted () {
    /** *clear localStorage user */
    localStorage.removeItem('mavAuth')
    localStorage.removeItem('mavRole')
    localStorage.removeItem('mavRoutes')
    localStorage.removeItem('user_manual')
    sessionStorage.removeItem('authCognito')

    this.$router.push({ name: 'login' })

    /** go here, refresh the page. not necesarry to clear state modules */
    this.$router.go()
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      'mutWarrantyClearModule': WARRANTY_CLEAR_MODULE
    }),
    ...mapMutations(USER_MODULE_NAME, {
      'mutUserClearModule': USER_CLEAR_MODULE
    })
  }
}
